<div class="material-datatable-wrapper">
  <app-datatable-headline
    [global_search_string]="global_search_string"
    [items_per_page_vars]="items_per_page_vars"
    (items_per_page_change)="itemPerPageChange($event)"
    (global_search_change)="onGlobalSearch($event)"
    [templateLeft]="inArchiveTmpl"
    [templateRight]="buttonCreate"
  ></app-datatable-headline>
  <div class="table-responsive">
    <table class="table table-striped datatable table-rwd">
      <thead app-data-table-head
             [sort]="sort"
             [columns]="columns"
             (sort_emmit)="onSortChange($event)">
      </thead>
      <tbody app-data-table-body
             (rowClick)="rowClick.emit($event)"
             [columns]="columns">
      </tbody>
    </table>
  </div>
  <app-datatable-pagination
    [current_page]="current_page"
    (change_page)="changePage($event)">
  </app-datatable-pagination>
</div>

<ng-template #buttonCreate>
  <div class="text-right">
    <a class="button" routerLink="/import/create">Новый фид...</a>
  </div>
</ng-template>

<ng-template #buttonTmpl let-row="row">
  <a class="button button_icon" [routerLink]="['/import/edit', row.id]">
    <i class="icon icon_Small_Edit"></i>
  </a>
</ng-template>

<ng-template #captionTmpl let-row="row">
  @switch (row.log_level) {
    @case ('info') {
      <i class="mr-1 text-info fa fa-fw fa-info-circle"></i>
    }
    @case ('notice') {
      <i class="mr-1 text-secondary fa fa-fw fa-bell"></i>
    }
    @case ('warning') {
      <i class="mr-1 text-warning fa fa-fw fa-exclamation-triangle"></i>
    }
    @case ('danger') {
      <i class="mr-1 text-danger fa fa-fw fa-exclamation-circle"></i>
    }
    @case ('error') {
      <i class="mr-1 text-danger fa fa-fw fa-times-circle"></i>
    }
    @case ('add') {
      <i class="mr-1 text-success fa fa-fw fa-plus-circle"></i>
    }
    @case ('delete') {
      <i class="mr-1 text-danger fa fa-fw fa-minus-circle"></i>
    }
    @case ('restore') {
      <i class="mr-1 text-success fa fa-fw fa-undo"></i>
    }
  }
  <span [class.text-warning]="row.log_level === 'warning'"
        [class.text-danger]="row.log_level === 'danger' || row.log_level === 'error' || row.log_level === 'delete'"
        [class.text-info]="row.log_level === 'info'"
        [class.text-success]="row.log_level === 'add' || row.log_level === 'restore'"
        [class.text-secondary]="row.log_level === 'notice'">{{row.caption}}</span>
</ng-template>

<ng-template #inArchiveTmpl>
  <div [formGroup]="customFilter">
    <app-material-input-checkbox title="Показывать отключенные фиды"
                                 formControlName="inArchive" [cssClass]="'mb-0'"
                                 [border]="true" [withMb0]="true"
    >
      <i class="fa fa-trash-o"></i>
    </app-material-input-checkbox>
  </div>
</ng-template>
